import React from 'react'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { AbortDeleteInterviewTemplateModal } from 'components/modals/AbortDeleteInterviewTemplateModal/AbortDeleteInterviewTemplateModal'
import { AbortEditInterviewTemplateModal } from 'components/modals/AbortEditInterviewTemplateModal/AbortEditInterviewTemplateModal'
import { CopyInterviewTemplateModal } from 'components/modals/CopyInterviewTemplateModal/CopyInterviewTemplateModal'
import { CreateInterviewTemplateModal } from 'components/modals/CreateInterviewTemplateModal/CreateInterviewTemplateModal'
import { DeleteInterviewTemplateModal } from 'components/modals/DeleteInterviewTemplateModal/DeleteInterviewTemplateModal'
import { Button } from 'components/shared/Button/Button'
import { Pane } from 'components/shared/Pane/Pane'
import { SearchWidget } from 'components/shared/SearchWidget/SearchWidget'
import { InterviewsTable } from './common/InterviewsTable/InterviewsTable'
import { DepartmentFilter } from 'components/shared/DepartmentFilter/DepartmentFilter'
import { useInterviewTemplates } from './hooks'

import { PlusCircleIcon } from 'components/shared/Icon/model'

import styles from './Interviews.module.scss'

export const Interviews = () => {
  const { state, handlers } = useInterviewTemplates()

  const {
    search,
    template,
    isCopyInterviewTemplateOpen,
    isCreateInterviewTemplateOpen,
    isDeleteInterviewTemplateOpen,
    isDeleteInformationOpen,
    isEditInformationOpen,
    departmentValue,
    filter,
  } = state
  const {
    handleCopyInterviewTemplateClose,
    handleCopyInterviewTemplateConfirm,
    handleCreateInteviewTemplateClose,
    handleCreateInterviewTemplateConfirm,
    handleCreateInteviewTemplateOpen,
    handleDeleteInterviewTemplateClose,
    handleDeleteInterviewTemplateConfirm,
    handleDeleteInformationClose,
    handleEditInformationClose,
    setDepartment,
    handleCopy,
    handleDelete,
    handleEdit,
    setSearch,
  } = handlers

  return (
    <>
      <Pane.Header className={styles.header}>
        <DepartmentFilter
          value={departmentValue}
          onChange={setDepartment}
          className={styles.departmentFilter}
        />
        <SearchWidget query={search} onChange={setSearch} />
        <Box>
          <Button
            className={styles.button}
            color="primary"
            icon={PlusCircleIcon}
            label={t`Interview template`}
            size="small"
            variant="filled"
            onClick={handleCreateInteviewTemplateOpen}
          />
        </Box>
      </Pane.Header>
      <InterviewsTable
        {...{ search, filter, handleCopy, handleDelete, handleEdit }}
      />
      <CreateInterviewTemplateModal
        onCancel={handleCreateInteviewTemplateClose}
        onClose={handleCreateInteviewTemplateClose}
        onConfirm={handleCreateInterviewTemplateConfirm}
        isOpen={isCreateInterviewTemplateOpen}
      />
      <AbortEditInterviewTemplateModal
        onClose={handleEditInformationClose}
        onConfirm={handleEditInformationClose}
        isOpen={isEditInformationOpen}
      />
      <AbortDeleteInterviewTemplateModal
        onClose={handleDeleteInformationClose}
        onConfirm={handleDeleteInformationClose}
        isOpen={isDeleteInformationOpen}
      />
      <CopyInterviewTemplateModal
        onCancel={handleCopyInterviewTemplateClose}
        onClose={handleCopyInterviewTemplateClose}
        onConfirm={handleCopyInterviewTemplateConfirm}
        isOpen={isCopyInterviewTemplateOpen}
        {...{ template }}
      />
      <DeleteInterviewTemplateModal
        onCancel={handleDeleteInterviewTemplateClose}
        onClose={handleDeleteInterviewTemplateClose}
        onConfirm={handleDeleteInterviewTemplateConfirm}
        isOpen={isDeleteInterviewTemplateOpen}
      />
    </>
  )
}
